import { BOOKS, VERSIONS } from "../../utils/constants";
import { Scripture } from "../types";

export const FirstThessalonians: Scripture = {
  version: VERSIONS.KJV,
  book: BOOKS.FIRST_THESSALONIANS,
  chapters: [
    {
      chapter: "1",
      verses: [
        {
          verse: "1",
          text: "Paul, and Silvanus, and Timotheus, unto the church of the Thessalonians which is in God the Father and in the Lord Jesus Christ: Grace be unto you, and peace, from God our Father, and the Lord Jesus Christ.",
        },
        {
          verse: "2",
          text: "We give thanks to God always for you all, making mention of you in our prayers;",
        },
        {
          verse: "3",
          text: "Remembering without ceasing your work of faith, and labour of love, and patience of hope in our Lord Jesus Christ, in the sight of God and our Father;",
        },
        {
          verse: "4",
          text: "Knowing, brethren beloved, your election of God.",
        },
        {
          verse: "5",
          text: "For our gospel came not unto you in word only, but also in power, and in the Holy Ghost, and in much assurance; as ye know what manner of men we were among you for your sake.",
        },
        {
          verse: "6",
          text: "And ye became followers of us, and of the Lord, having received the word in much affliction, with joy of the Holy Ghost:",
        },
        {
          verse: "7",
          text: "So that ye were ensamples to all that believe in Macedonia and Achaia.",
        },
        {
          verse: "8",
          text: "For from you sounded out the word of the Lord not only in Macedonia and Achaia, but also in every place your faith to God-ward is spread abroad; so that we need not to speak any thing.",
        },
        {
          verse: "9",
          text: "For they themselves shew of us what manner of entering in we had unto you, and how ye turned to God from idols to serve the living and true God;",
        },
        {
          verse: "10",
          text: "And to wait for his Son from heaven, whom he raised from the dead, even Jesus, which delivered us from the wrath to come.",
        },
      ],
    },
    {
      chapter: "2",
      verses: [
        {
          verse: "1",
          text: "For yourselves, brethren, know our entrance in unto you, that it was not in vain:",
        },
        {
          verse: "2",
          text: "But even after that we had suffered before, and were shamefully entreated, as ye know, at Philippi, we were bold in our God to speak unto you the gospel of God with much contention.",
        },
        {
          verse: "3",
          text: "For our exhortation was not of deceit, nor of uncleanness, nor in guile:",
        },
        {
          verse: "4",
          text: "But as we were allowed of God to be put in trust with the gospel, even so we speak; not as pleasing men, but God, which trieth our hearts.",
        },
        {
          verse: "5",
          text: "For neither at any time used we flattering words, as ye know, nor a cloke of covetousness; God is witness:",
        },
        {
          verse: "6",
          text: "Nor of men sought we glory, neither of you, nor yet of others, when we might have been burdensome, as the apostles of Christ.",
        },
        {
          verse: "7",
          text: "But we were gentle among you, even as a nurse cherisheth her children:",
        },
        {
          verse: "8",
          text: "So being affectionately desirous of you, we were willing to have imparted unto you, not the gospel of God only, but also our own souls, because ye were dear unto us.",
        },
        {
          verse: "9",
          text: "For ye remember, brethren, our labour and travail: for labouring night and day, because we would not be chargeable unto any of you, we preached unto you the gospel of God.",
        },
        {
          verse: "10",
          text: "Ye are witnesses, and God also, how holily and justly and unblameably we behaved ourselves among you that believe:",
        },
        {
          verse: "11",
          text: "As ye know how we exhorted and comforted and charged every one of you, as a father doth his children,",
        },
        {
          verse: "12",
          text: "That ye would walk worthy of God, who hath called you unto his kingdom and glory.",
        },
        {
          verse: "13",
          text: "For this cause also thank we God without ceasing, because, when ye received the word of God which ye heard of us, ye received it not as the word of men, but as it is in truth, the word of God, which effectually worketh also in you that believe.",
        },
        {
          verse: "14",
          text: "For ye, brethren, became followers of the churches of God which in Judaea are in Christ Jesus: for ye also have suffered like things of your own countrymen, even as they have of the Jews:",
        },
        {
          verse: "15",
          text: "Who both killed the Lord Jesus, and their own prophets, and have persecuted us; and they please not God, and are contrary to all men:",
        },
        {
          verse: "16",
          text: "Forbidding us to speak to the Gentiles that they might be saved, to fill up their sins alway: for the wrath is come upon them to the uttermost.",
        },
        {
          verse: "17",
          text: "But we, brethren, being taken from you for a short time in presence, not in heart, endeavoured the more abundantly to see your face with great desire.",
        },
        {
          verse: "18",
          text: "Wherefore we would have come unto you, even I Paul, once and again; but Satan hindered us.",
        },
        {
          verse: "19",
          text: "For what is our hope, or joy, or crown of rejoicing? Are not even ye in the presence of our Lord Jesus Christ at his coming?",
        },
        { verse: "20", text: "For ye are our glory and joy." },
      ],
    },
    {
      chapter: "3",
      verses: [
        {
          verse: "1",
          text: "Wherefore when we could no longer forbear, we thought it good to be left at Athens alone;",
        },
        {
          verse: "2",
          text: "And sent Timotheus, our brother, and minister of God, and our fellowlabourer in the gospel of Christ, to establish you, and to comfort you concerning your faith:",
        },
        {
          verse: "3",
          text: "That no man should be moved by these afflictions: for yourselves know that we are appointed thereunto.",
        },
        {
          verse: "4",
          text: "For verily, when we were with you, we told you before that we should suffer tribulation; even as it came to pass, and ye know.",
        },
        {
          verse: "5",
          text: "For this cause, when I could no longer forbear, I sent to know your faith, lest by some means the tempter have tempted you, and our labour be in vain.",
        },
        {
          verse: "6",
          text: "But now when Timotheus came from you unto us, and brought us good tidings of your faith and charity, and that ye have good remembrance of us always, desiring greatly to see us, as we also to see you:",
        },
        {
          verse: "7",
          text: "Therefore, brethren, we were comforted over you in all our affliction and distress by your faith:",
        },
        { verse: "8", text: "For now we live, if ye stand fast in the Lord." },
        {
          verse: "9",
          text: "For what thanks can we render to God again for you, for all the joy wherewith we joy for your sakes before our God;",
        },
        {
          verse: "10",
          text: "Night and day praying exceedingly that we might see your face, and might perfect that which is lacking in your faith?",
        },
        {
          verse: "11",
          text: "Now God himself and our Father, and our Lord Jesus Christ, direct our way unto you.",
        },
        {
          verse: "12",
          text: "And the Lord make you to increase and abound in love one toward another, and toward all men, even as we do toward you:",
        },
        {
          verse: "13",
          text: "To the end he may stablish your hearts unblameable in holiness before God, even our Father, at the coming of our Lord Jesus Christ with all his saints.",
        },
      ],
    },
    {
      chapter: "4",
      verses: [
        {
          verse: "1",
          text: "Furthermore then we beseech you, brethren, and exhort you by the Lord Jesus, that as ye have received of us how ye ought to walk and to please God, so ye would abound more and more.",
        },
        {
          verse: "2",
          text: "For ye know what commandments we gave you by the Lord Jesus.",
        },
        {
          verse: "3",
          text: "For this is the will of God, even your sanctification, that ye should abstain from fornication:",
        },
        {
          verse: "4",
          text: "That every one of you should know how to possess his vessel in sanctification and honour;",
        },
        {
          verse: "5",
          text: "Not in the lust of concupiscence, even as the Gentiles which know not God:",
        },
        {
          verse: "6",
          text: "That no man go beyond and defraud his brother in any matter: because that the Lord is the avenger of all such, as we also have forewarned you and testified.",
        },
        {
          verse: "7",
          text: "For God hath not called us unto uncleanness, but unto holiness.",
        },
        {
          verse: "8",
          text: "He therefore that despiseth, despiseth not man, but God, who hath also given unto us his holy Spirit.",
        },
        {
          verse: "9",
          text: "But as touching brotherly love ye need not that I write unto you: for ye yourselves are taught of God to love one another.",
        },
        {
          verse: "10",
          text: "And indeed ye do it toward all the brethren which are in all Macedonia: but we beseech you, brethren, that ye increase more and more;",
        },
        {
          verse: "11",
          text: "And that ye study to be quiet, and to do your own business, and to work with your own hands, as we commanded you;",
        },
        {
          verse: "12",
          text: "That ye may walk honestly toward them that are without, and that ye may have lack of nothing.",
        },
        {
          verse: "13",
          text: "But I would not have you to be ignorant, brethren, concerning them which are asleep, that ye sorrow not, even as others which have no hope.",
        },
        {
          verse: "14",
          text: "For if we believe that Jesus died and rose again, even so them also which sleep in Jesus will God bring with him.",
        },
        {
          verse: "15",
          text: "For this we say unto you by the word of the Lord, that we which are alive and remain unto the coming of the Lord shall not prevent them which are asleep.",
        },
        {
          verse: "16",
          text: "For the Lord himself shall descend from heaven with a shout, with the voice of the archangel, and with the trump of God: and the dead in Christ shall rise first:",
        },
        {
          verse: "17",
          text: "Then we which are alive and remain shall be caught up together with them in the clouds, to meet the Lord in the air: and so shall we ever be with the Lord.",
        },
        {
          verse: "18",
          text: "Wherefore comfort one another with these words.",
        },
      ],
    },
    {
      chapter: "5",
      verses: [
        {
          verse: "1",
          text: "But of the times and the seasons, brethren, ye have no need that I write unto you.",
        },
        {
          verse: "2",
          text: "For yourselves know perfectly that the day of the Lord so cometh as a thief in the night.",
        },
        {
          verse: "3",
          text: "For when they shall say, Peace and safety; then sudden destruction cometh upon them, as travail upon a woman with child; and they shall not escape.",
        },
        {
          verse: "4",
          text: "But ye, brethren, are not in darkness, that that day should overtake you as a thief.",
        },
        {
          verse: "5",
          text: "Ye are all the children of light, and the children of the day: we are not of the night, nor of darkness.",
        },
        {
          verse: "6",
          text: "Therefore let us not sleep, as do others; but let us watch and be sober.",
        },
        {
          verse: "7",
          text: "For they that sleep sleep in the night; and they that be drunken are drunken in the night.",
        },
        {
          verse: "8",
          text: "But let us, who are of the day, be sober, putting on the breastplate of faith and love; and for an helmet, the hope of salvation.",
        },
        {
          verse: "9",
          text: "For God hath not appointed us to wrath, but to obtain salvation by our Lord Jesus Christ,",
        },
        {
          verse: "10",
          text: "Who died for us, that, whether we wake or sleep, we should live together with him.",
        },
        {
          verse: "11",
          text: "Wherefore comfort yourselves together, and edify one another, even as also ye do.",
        },
        {
          verse: "12",
          text: "And we beseech you, brethren, to know them which labour among you, and are over you in the Lord, and admonish you;",
        },
        {
          verse: "13",
          text: "And to esteem them very highly in love for their work\u2019s sake. And be at peace among yourselves.",
        },
        {
          verse: "14",
          text: "Now we exhort you, brethren, warn them that are unruly, comfort the feebleminded, support the weak, be patient toward all men.",
        },
        {
          verse: "15",
          text: "See that none render evil for evil unto any man; but ever follow that which is good, both among yourselves, and to all men.",
        },
        { verse: "16", text: "Rejoice evermore." },
        { verse: "17", text: "Pray without ceasing." },
        {
          verse: "18",
          text: "In every thing give thanks: for this is the will of God in Christ Jesus concerning you.",
        },
        { verse: "19", text: "Quench not the Spirit." },
        { verse: "20", text: "Despise not prophesyings." },
        {
          verse: "21",
          text: "Prove all things; hold fast that which is good.",
        },
        { verse: "22", text: "Abstain from all appearance of evil." },
        {
          verse: "23",
          text: "And the very God of peace sanctify you wholly; and I pray God your whole spirit and soul and body be preserved blameless unto the coming of our Lord Jesus Christ.",
        },
        {
          verse: "24",
          text: "Faithful is he that calleth you, who also will do it.",
        },
        { verse: "25", text: "Brethren, pray for us." },
        { verse: "26", text: "Greet all the brethren with an holy kiss." },
        {
          verse: "27",
          text: "I charge you by the Lord that this epistle be read unto all the holy brethren.",
        },
        {
          verse: "28",
          text: "The grace of our Lord Jesus Christ be with you. Amen.",
        },
      ],
    },
  ],
};
